import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeSnippet = ({ language, description, code }) => {
  return (
    <div className="section section-dark" style={{ display: 'flex', flexDirection: 'column' }}>
      
      {/* Inizio <div> per la descrizione del codice */}
      <div style={{ padding: '16px', backgroundColor: '#333', borderRadius: '4px', marginBottom: '16px' }}>
        <p style={{ color: '#fff', margin: '0' }}>{description}</p>
      </div>
      {/* Fine <div> per la descrizione del codice */}
      
      {/* Inizio <div> per il codice */}
      <div style={{ backgroundColor: '#333', borderRadius: '4px' }}>
        <SyntaxHighlighter language={language} style={materialDark}>
          {code}
        </SyntaxHighlighter>
      </div>
      {/* Fine <div> per il codice */}
      
    </div>
  );
};

export default CodeSnippet;
